import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";
import lozad from "lozad";
import { Prop } from "vue-property-decorator";
/**
 * Component used to lazy load images.
 * The image automatically takes 100% of the parent's space
 */

var MatImage = /*#__PURE__*/function (_Vue) {
  _inherits(MatImage, _Vue);

  var _super = _createSuper(MatImage);

  function MatImage() {
    var _this;

    _classCallCheck(this, MatImage);

    _this = _super.apply(this, arguments);
    _this.loading = true;
    return _this;
  }

  _createClass(MatImage, [{
    key: "style",
    get: function get() {
      // The background color is used as a
      // placeholder while loading the image.
      // You can use the dominant color of the
      // image to improve perceived performance.
      // See: https://manu.ninja/dominant-colors-for-lazy-loading-images/
      var style = {
        backgroundColor: this.backgroundColor
      };
      if (this.width) style.width = "".concat(this.width, "px");else style.width = "100%"; // If the image is still loading we
      // apply the image's aspect ratio by
      // using padding top.
      // NOTE: the aspect ratio is pre-calculated
      // for our images, since they are all
      // of the same size (1024 x 512)

      if (this.loading) {
        // Prevent flash of unstyled image
        // after the image is loaded.
        style.height = 0; // Scale the image container according
        // to the aspect ratio.

        style.paddingTop = "50%";
      }

      return style;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      var imgElement = this.$refs.img; // As soon as the <img> element triggers
      // the `load` event, the loading state is
      // set to `false`, which removes the apsect
      // ratio we've applied earlier.

      var setLoadingState = function setLoadingState() {
        _this2.loading = false;
      };

      imgElement.addEventListener("load", setLoadingState); // Handle the error event

      imgElement.addEventListener("error", function () {
        imgElement.setAttribute("style", "display: none");

        _this2.$refs.erroricon.setAttribute("style", "display: block");
      }); // We remove the event listener as soon as
      // the component is destroyed to prevent
      // potential memory leaks.

      this.$once("hook:destroyed", function () {
        imgElement.removeEventListener("load", setLoadingState);
      }); // We initialize Lozad.js on the root
      // element of our component.

      var observer = lozad(imgElement);
      observer.observe();
    }
  }]);

  return MatImage;
}(Vue);

__decorate([Prop()], MatImage.prototype, "backgroundColor", void 0);

__decorate([Prop()], MatImage.prototype, "width", void 0);

__decorate([Prop()], MatImage.prototype, "height", void 0);

__decorate([Prop()], MatImage.prototype, "lazySrc", void 0);

__decorate([Prop()], MatImage.prototype, "lazySrcset", void 0);

MatImage = __decorate([Component({})], MatImage);
export default MatImage;